import { Routes } from '@angular/router';
import { clientsRoute } from './clients/clients.config';
import { PageKey } from '../../../shared/services/page/models/page.key';
import { iatfRoutes } from './iatf/iatf.config';
import { canActivate } from '../../../shared/guard/guard';
import { HeaderEnum, PermissionEnum } from '../../../../environments/shared-environment/permission';

export const documentsManageRoute: Routes = [{
  path: 'documents/manage',
  canActivateChild: [() => canActivate(HeaderEnum.DOCS_MANAGE, PermissionEnum.VIEW)],
  loadComponent: () => import('./documents-manage.component').then(m => m.DocumentsManageComponent),
  children: [
    {
      path: '',
      loadComponent: () => import('./iatf/list/list.component').then(m => m.ListIatfComponent),
      data: {
        title: 'Visualizar Normas',
        key: PageKey.MANAGE
      },
    },
    ...clientsRoute,
    ...iatfRoutes,
  ]
}];
